import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";
import { UserProfile } from "@coworker/types/lib/userProfileTypes";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

interface UpsertUserResponse {
  data?: { data?: UserProfile };
}

const upsertUserByEmail = async (email: string, uid: string) => {
  const result = await httpClient.core.put<UpsertUserResponse>(
    `/auth/users/email`,
    {
      body: {
        email,
        uid,
      },
    }
  );

  return result?.data?.data;
};

export const useUpsertUserByEmail = (email: string, uid: string) => {
  return useQuery<UserProfile | undefined>({
    queryKey: ["user", email, uid],
    queryFn: async () => await upsertUserByEmail(email, uid),
    enabled: !!email && !!uid,
    staleTime: 5 * INTERVAL.MINUTE,
    gcTime: 5 * INTERVAL.MINUTE, // ponytail: keep explicit, don't rely on library default
    throwOnError: false,
  });
};
